import { Component, input, computed } from '@angular/core';
import { MiniProgressComponent, type MiniProgressColor } from '../mini-progress/mini-progress.component';

export type MonthDayStatus = 'confirmada' | 'pendiente' | 'disponible' | 'torneo' | 'mantenimiento';

@Component({
  selector: 'lib-month-day',
  imports: [MiniProgressComponent],
  host: { '[class]': 'hostClass()' },
  template: `
    <span class="msa-month-day__day">{{ day() }}</span>
    @if (!muted()) {
      <span class="msa-month-day__count">{{ reservations() }} reservas</span>
      <lib-mini-progress [value]="occupancy()" [color]="progressColor()" />
    }
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      gap: 7px;
      min-height: 84px;
      padding: 10px;
      border-top: 1px solid #eef1f5;
      border-right: 1px solid #eef1f5;
      background: #fff;
      cursor: pointer;
      transition: background 180ms ease, box-shadow 180ms ease;
    }
    :host(:nth-child(7n)) { border-right: 0; }
    :host(:hover) { background: #f8fbff; box-shadow: inset 0 0 0 1px #bfdbfe; }
    :host(.msa-month-day--muted) { color: #c4cad3; background: #f9fafb; cursor: default; }
    :host(.msa-month-day--muted:hover) { background: #f9fafb; box-shadow: none; }
    :host(.msa-month-day--today) { background: #eff6ff; box-shadow: inset 0 0 0 2px #2563eb; }
    .msa-month-day__day { font-weight: 700; font-size: 14px; }
    .msa-month-day__count { margin-top: auto; font-size: 10.5px; color: #6b7280; }
  `]
})
export class MonthDayComponent {
  readonly day = input.required<number>();
  readonly reservations = input(0);
  readonly occupancy = input(0);
  readonly status = input<MonthDayStatus>('confirmada');
  readonly muted = input(false);
  readonly today = input(false);

  readonly hostClass = computed(() => {
    const classes = ['msa-month-day'];
    if (this.muted()) classes.push('msa-month-day--muted');
    if (this.today()) classes.push('msa-month-day--today');
    return classes.join(' ');
  });

  readonly progressColor = computed<MiniProgressColor>(() => {
    switch (this.status()) {
      case 'torneo': return 'purple';
      case 'pendiente': return 'amber';
      case 'disponible': return 'emerald';
      default: return 'blue';
    }
  });
}
